export default "__VITE_ASSET__CbIoqxRh__"